import React from 'react'

export const DashboardHeader = ({ title = 'Titulo', children, text = '', total = 0 }) => {
  return (
    <div className="admin-header">
      <h4 style={{ color: '#01A8E7' }}>
        {title}
        {!!total && (
          <span style={{ fontWeight: 400, fontSize: 18, padding: 10 }}>
            ( {total} {text} )
          </span>
        )}
      </h4>

      <span style={{ display: 'flex', alignItems: 'center' }}>{children}</span>
    </div>
  )
}
